// extracted by mini-css-extract-plugin
module.exports = {"tag":"style_tag__2EK9a","loader":"style_loader__Vr91v","text":"style_text__vI3xT"};